/**
 * Job Posting Translations - English (EN-US)
 */
export const jobEn = {
  // Section headings
  'job.sections.aboutRole': 'About the Role',
  'job.sections.responsibilities': 'Responsibilities',
  'job.sections.requirements': 'Requirements',
  'job.sections.technicalSkills': 'Technical Skills',
  'job.sections.behavioralSkills': 'Behavioral Skills',
  'job.sections.benefits': 'Benefits',
  'job.sections.compensation': 'Compensation',

  // Work mode
  'job.workMode.remote': 'Remote',
  'job.workMode.hybrid': 'Hybrid',
  'job.workMode.onsite': 'On-site',

  // Employment type (backend: clt | pj | internship | temporary)
  'job.employmentType.clt': 'CLT',
  'job.employmentType.pj': 'PJ',
  'job.employmentType.internship': 'Internship',
  'job.employmentType.temporary': 'Temporary',

  // Seniority
  'job.seniority.junior': 'Junior',
  'job.seniority.mid': 'Mid-level',
  'job.seniority.senior': 'Senior',
  'job.seniority.lead': 'Lead',
  'job.seniority.principal': 'Principal',

  // Apply button
  'job.apply.button': 'Apply Now',
  'job.apply.ariaLabel': 'Apply for this position',

  // Error states
  'job.error.invalidPosting': 'Invalid Job Posting',
  'job.error.noJobId': 'No job ID provided in the URL.',
  'job.error.notFound': 'Job Posting Not Found',
  'job.error.unableToLoad': 'Unable to Load Job Posting',
  'job.error.notFoundDescription': 'This job posting could not be found. It may have been closed or removed.',
  'job.error.unableToLoadDescription': 'Unable to load job posting. Please check your connection and try again.',
}
